import api from '#config/api';

export const createChecklist = values => api.post('/checklists', values);

export const getAllChecklists = type => api.get(`/checklists/${type}`);

export const editChecklist = ({ id, ...values }) => api.put(`/checklists/${id}`, values);

export const deleteChecklist = id => api.put(`/checklists/${id}/delete`);
